export enum AuthEventName {
  Unauthorized = "pantrystack:unauthorized",
}
